module.exports = __webpack_public_path__ + "img/Unterkunft.dfcfd0c1.svg";